/**
 * Job Types
 * We can add more types in the future such as Github Actions, etc.
 */
export const JobTypes = {
    DEPLOY: 1,
    DELETE: 2,
};
/**
 * Job Status
 */
export const JobStatus = {
    IN_PROGRESS: 1,
    SUCCESS: 2,
    FAILED: 3,
    PENDING: 4,
    SKIPPED: 5,
};
